import { render, staticRenderFns } from "./ManageFeaturesPage.vue?vue&type=template&id=35a92cea&scoped=true"
import script from "./ManageFeaturesPage.vue?vue&type=script&lang=ts"
export * from "./ManageFeaturesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a92cea",
  null
  
)

export default component.exports